import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ProductlistComponent } from './product/productlist/productlist.component';
import { CategorylistComponent } from './category/categorylist/categorylist.component';
import { AddproductComponent } from './product/addproduct/addproduct.component';
import { TrendingComponent } from './trending/trending/trending.component';
import { ProductdetailComponent } from './product/productdetail/productdetail.component';
import { UpdateproductComponent } from './product/updateproduct/updateproduct.component';

import { AuthGuard } from './_guard/auth.guard';
import { AddstockComponent } from './stock/addstock/addstock.component';
import { IndexingUrlComponent } from './indexing-url/indexing-url.component';

const routes: Routes = [
  {
    path: '', component: DashboardComponent, canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'categories', pathMatch: 'full' },
      { path: 'categories', component: CategorylistComponent },
      { path: 'addStock', component: AddstockComponent },
      { path: 'addProduct', component: AddproductComponent },
      { path: 'products', component: ProductlistComponent },
      { path: 'updateProduct', component: UpdateproductComponent },
      { path: 'productDetails', component: ProductdetailComponent },
      { path: 'trending', component: TrendingComponent },
      { path: 'indexing', component: IndexingUrlComponent },
    ],
  },
  { path: 'signin', component: LoginComponent },
  { path: '**', component: PagenotfoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
